import { DeliveryAnalyticsAggregatesSchema } from "@redotech/redo-model/analytics/analytics";
import z from "zod/v4";

export const getDeliveryAnalyticsAggregates = {
  name: "getDeliveryAnalyticsAggregates",
  input: z.object({ numUnits: z.number().positive(), startDate: z.date() }),
  output: DeliveryAnalyticsAggregatesSchema,
};
